<template>
    <div class="main-container">
        <customModalDialog :settings="customModalSettings"></customModalDialog>
        <div class="range">
            <div class="range-select__wrapper">
                <div class="range-select">
                    <div class="dropdown-range">
                        <h6>{{ translate('own_selectRange') }}:</h6>
                        <b-dropdown :text="getDateRangeTypeTranslation()" no-caret>
                            <b-dropdown-item v-on:click="onDateTypeClick(CONSTANTS.TODAY)">
                                <span>{{ translate('own_today') }}</span>
                            </b-dropdown-item>
                            <b-dropdown-item v-on:click="onDateTypeClick(CONSTANTS.LAST7DAYS)">
                                <span>{{ translate('own_last7days') }}</span>
                            </b-dropdown-item>
                            <b-dropdown-item v-on:click="onDateTypeClick(CONSTANTS.ALL_TIME)">
                                <span>{{ this.translate('own_allTime') }}</span>
                            </b-dropdown-item>
                            <b-dropdown-item v-on:click="onDateTypeClick(CONSTANTS.CUSTOM)">
                                <span>{{ this.translate('own_custom') }}...</span>
                            </b-dropdown-item>
                        </b-dropdown>
                    </div>
                    <div class="dropdown-range dates" v-if="dateRange.type == CONSTANTS.CUSTOM">
                        <div class="calendar-inline">
                            <div class="custom_date_selector">
                                <label class="date_lbl">{{ translate('From') }}:</label>
                                <div :class="[!dateRangeView.showDateFrom ? 'hide-picker' : '']">
                                    <date-picker
                                        name="date"
                                        id="datefrom"
                                        v-model="dateRangeView.dateFrom"
                                        :config="dateRangeView.options"
                                        @dp-hide="onDatePickerHidden"
                                        @dp-change="onDateFromChanged"
                                    ></date-picker>
                                </div>
                                <label @click="dateRangeView.showDateFrom = !dateRangeView.showDateFrom" class="btn"
                                       for="datefrom">
                                    <img src="@/assets/icons/ic_calendar-1.svg">
                                </label>
                            </div>
                        </div>
                        <div class="calendar-inline">
                            <div class="custom_date_selector">
                                <label class="date_lbl">{{ translate('To') }}:</label>
                                <div :class="[!dateRangeView.showDateTo ? 'hide-picker' : '']">
                                    <date-picker
                                        name="date"
                                        id="dateto"
                                        v-model="dateRangeView.dateTo"
                                        :config="dateRangeView.options"
                                        @dp-hide="onDatePickerHidden"
                                        @dp-change="onDateToChanged"></date-picker>
                                </div>
                                <label @click="dateRangeView.showDateTo = !dateRangeView.showDateTo" class="btn"
                                       for="dateto">
                                    <img src="@/assets/icons/ic_calendar-1.svg">
                                </label>
                            </div>
                        </div>
                    </div>
                    <div class="dropdown-range">
                        <h6>{{ translate('Filter') }}</h6>
                        <b-form-input
                            v-model="search.filter"
                            :placeholder="translate('own_filter_placeholder')"
                            class="search_places"
                        ></b-form-input>
                    </div>
                    <div style="flex-grow: 1;"></div>
                    <button
                        class="primaryButton additional_service" @click="fetchReport('xlsx')">
                        <span class="order-btn__text">{{translate('exportTo')}} XLSX</span>
                    </button>
                </div>
            </div>
        </div>
        <div class="items-container">
            <table class="items-table">
                <tr class="table-header">
                    <td style="min-width: 130px; width: 130px;" class="first-col">{{ translate('serviceLogsDate') }}</td>
                    <td style="width: 52px; min-width: 52px">{{ translate('serviceLogsStickerId') }}</td>
                    <td style="width: 100px; min-width: 100px">{{ translate('serviceLogsAssetId') }}</td>
                    <td style="width: 120px; min-width: 120px">{{ translate('serviceLogsLocation') }}</td>
                    <td style="width: 30px; min-width: 30px">{{ translate('serviceLogsGPS') }}</td>
                    <td style="width: 120px; min-width: 100px">{{ translate('serviceLogsServices') }}</td>
                    <td style="width: 170px; min-width: 170px">{{ translate('serviceLogsData') }}</td>
                    <td style="width: 150px; min-width: 150px">{{ translate('serviceLogsComments') }}</td>
                    <td style="width: 150px; min-width: 70px">{{ translate('serviceLogsPictures') }}</td>
                    <td style="width: 200px; min-width: 50px">{{ translate('serviceLogsAudio') }}</td>
                    <td style="width: 200px; min-width: 150px" class="last-col">{{ translate('serviceLogsUser') }}</td>
                </tr>
                <tr class="table-row" v-for="(item, index) in items" :key="index">
                    <td>{{ item.created_at | moment("MM/DD/YYYY HH:mm") }}</td>
                    <td style="text-align: center">{{ item.question.id }}</td>
                    <td>{{ item.question.asset_id }}</td>
                    <td>{{ item.placement }}</td>
                    <td style="text-align: center;"><img src="@/assets/icons/ic_google_map.svg" style="cursor: pointer"
                                                         v-if="item.rate_location" @click="openRateLocation(item)"></td>
                    <td style="white-space: pre-wrap;">{{ getServices(item) }}</td>
                    <td style="white-space: pre-wrap;">{{ item.data || '' }}</td>
                    <td style="word-break: break-word;">{{ item.comment }}</td>
                    <td style="vertical-align: top;">
                        <div class="attachments" v-if="item.attachments.images.length > 0">
                            <img v-for="(item, index) in item.attachments.images"
                                 :key="index"
                                 :src="item.previewUrl"
                                 @click="onVoteImageClick(item)"/>
                        </div>
                    </td>
                    <td>
                        <audio controls v-if="item.attachments.audio" :src="item.attachments.audio.audio_url"
                               class="vote-audio"></audio>
                    </td>
                    <td class="last-col">{{ item.user ? item.user.email : '' }}</td>
                </tr>
            </table>
            <infinite-loading :identifier="infiniteId" @infinite="loadLinks" ref="infinite-loading">
                <div slot="no-more"></div>
                <div slot="no-results" class="infinite-no-results">
                    <span>{{ translate('serviceLogsDashboardNoLogsFound') }}</span>
                    <div style="display: flex; margin-top: 12px;">
                    <b-button class="no_data_reset_btn" v-if="!isDateRangeAllTime()" @click="onDateTypeClick(CONSTANTS.ALL_TIME)">
                        {{ translate('serviceLogsDashboardClearDateRange') }}
                    </b-button>
                    <span v-if="!isDateRangeAllTime() && search.filter != ''" style="margin-left: 12px; margin-right: 12px; line-height: 36px">or</span>
                    <b-button class="no_data_reset_btn" v-if="search.filter != ''" @click="search.filter=''">
                        {{ translate('serviceLogsDashboardClearFilters') }}
                    </b-button>
                    </div>
                </div>
            </infinite-loading>
        </div>
        <div @click="refreshAll" class="refresh-btn">{{ translate('airLeadDashboardRefresh') }}</div>
    </div>
</template>

<script>
import {mapActions, mapGetters, mapMutations, mapState} from "vuex";
import InfiniteLoading from "vue-infinite-loading";
import customModalDialog from '@/components/widgets/customModalDialog';
import moment from 'moment'
import errorMixin from '@/mixins/errorMixin';
import CONSTANTS from '@/store/modules/serviceLog'
import datePicker from "vue-bootstrap-datetimepicker";
import 'pc-bootstrap4-datetimepicker/build/css/bootstrap-datetimepicker.css';
import logAnalyticsEvent, {logError} from "@/helpers/analytics";

export default {
    name: 'serviceLogDashboard',
    mixins: [mixin, errorMixin],
    components: {
        InfiniteLoading,
        customModalDialog,
        datePicker,
    },
    data() {
        return {
            CONSTANTS: CONSTANTS,
            items: [],
            page: 1,
            counter: 0,
            infiniteId: +new Date(),
            loadingAction: false,
            customModalSettings: {},
            search: {
                filter: '',
                timerDelay: null,
            },
            dateFormat: moment.ISO_8601,
            dateRange: {
                type: 'last7days',
                dateFrom: null,
                dateTo: null,
            },
            dateRangeView: {
                dateFrom: null,
                dateTo: null,
                showDateFrom: false,
                showDateTo: false,
                options: {
                    format: 'MM/DD/YYYY H:mm',
                    useCurrent: false,
                    minDate: false,
                    maxDate: false,
                    keyBinds: false
                },
            },
            totalItems: 0,
        }
    },
    computed: {
        ...mapState({
            accounts: state => state.closeAccount.accounts,
            userInfo: state => state.auth.userInfo,
        })
    },
    watch: {
        'search.filter'(val) {
            if (this.search.timerDelay) {
                clearTimeout(this.search.timerDelay);
            }
            this.search.timerDelay = setTimeout(() => {
                this.refreshAll()
            }, 300);
            this.updateSearchParams()
        },
    },
    mounted() {
        this.parseDateRange()
        this.parseSearchParams()
    },
    methods: {
        ...mapGetters({}),
        ...mapActions({
            getServiceLogs: 'serviceLog/getServiceLogs',
            openFileReport: 'organization/openFileReport',
            checkReport: 'organization/checkReport',
            createXlsxReportTask: 'organization/createXlsxReportTask',
        }),

        ...mapMutations({
            setMessageModel: 'setMessageModel',
            setProgressBarTag: 'setProgressBarTag',
        }),

        parseDateRange() {
            let dateFormat = this.dateFormat
            let dateRange = this.$route.query.date_type
            // let rangeFrom = moment("2015-06-22T13:17:21+0000", dateFormat, true).isValid()
            let rangeFrom = moment(this.$route.query.from, dateFormat, true).isValid() ? this.$route.query.from : null
            let rangeTo = moment(this.$route.query.to, dateFormat, true).isValid() ? this.$route.query.to : null

            if (rangeFrom != null && rangeTo != null) {
                dateRange = CONSTANTS.CUSTOM
                this.dateRange.dateFrom = rangeFrom
                this.dateRange.dateTo = rangeTo
            } else {
                switch (dateRange) {
                    case CONSTANTS.TODAY: {
                        break;
                    }
                    case CONSTANTS.LAST7DAYS: {
                        break;
                    }
                    case CONSTANTS.ALL_TIME: {
                        break;
                    }
                    case CONSTANTS.CUSTOM: {
                        dateRange = CONSTANTS.LAST7DAYS
                        //todo show error parsing date parameters if needed?
                        break;
                    }
                    default: {
                        dateRange = CONSTANTS.LAST7DAYS
                    }
                }
            }
            this.dateRange.type = dateRange
            this.updateDateParams()
        },
        isDateRangeAllTime() {
            return this.dateRange.type == CONSTANTS.ALL_TIME
        },
        getDateRangeTypeTranslation() {
            let str = ''
            switch (this.dateRange.type) {
                case CONSTANTS.TODAY: {
                    str = 'own_today'
                    break;
                }
                case CONSTANTS.LAST7DAYS: {
                    str = 'own_last7days'
                    break;
                }
                case CONSTANTS.ALL_TIME: {
                    str = 'own_allTime'
                    break;
                }
                case CONSTANTS.CUSTOM: {
                    str = 'own_custom'
                    break;
                }
            }
            return this.translate(str)
        },
        onDateTypeClick(type) {
            let oldRange = this.dateRange.type
            if (oldRange == type) return
            this.dateRange.type = type
            if (type == CONSTANTS.CUSTOM) {
                switch (oldRange) {
                    case CONSTANTS.TODAY: {
                        this.dateRange.dateFrom = moment().startOf('day').toISOString(true)
                        this.dateRange.dateTo = moment().endOf('day').toISOString(true)
                        break;
                    }
                    case CONSTANTS.LAST7DAYS: {
                        console.log('kek lol')
                        this.dateRange.dateFrom = moment().subtract(7, 'days').startOf('day').toISOString(true)
                        this.dateRange.dateTo = moment().endOf('day').toISOString(true)
                        break;
                    }
                    case CONSTANTS.ALL_TIME: {
                        this.dateRange.dateFrom = moment().startOf('day').toISOString(true)
                        this.dateRange.dateTo = moment().endOf('day').toISOString(true)
                        break;
                    }
                }
            } else {
                this.dateRange.dateFrom = null
                this.dateRange.dateTo = null
            }
            this.updateDateParams()
            this.refreshAll()
        },

        updateDateParams() {
            this.updateRangeViewFromRange()
            let query = JSON.parse(JSON.stringify(this.$route.query))
            delete query['from']
            delete query['to']
            query.date_type = this.dateRange.type
            if (this.dateRange.dateFrom) query.from = this.dateRange.dateFrom
            if (this.dateRange.dateTo) query.to = this.dateRange.dateTo
            this.$router.push({
                path: this.$route.path, query: query
            })
        },
        parseSearchParams() {
            let search = this.$route.query.filter
            if(search && search != '') {
                this.search.filter = search
            }
        },
        updateSearchParams() {
            let query = JSON.parse(JSON.stringify(this.$route.query))
            delete query['filter']
            if (this.search.filter != '') query.filter = this.search.filter
            this.$router.push({
                path: this.$route.path, query: query
            })
        },
        onDatePickerHidden() {
            this.refreshAll()
            this.dateRangeView.showDateFrom = false;
            this.dateRangeView.showDateTo = false;
        },
        updateRangeViewFromRange() {
            if (this.dateRange.dateFrom && this.dateRange.dateTo) {
                this.dateRangeView.dateFrom = moment(this.dateRange.dateFrom).format(this.dateRangeView.options.format)
                this.dateRangeView.dateTo = moment(this.dateRange.dateTo).format(this.dateRangeView.options.format)
            }
        },
        onDateFromChanged() {
            if (this.dateRangeView.dateFrom) {
                this.dateRange.dateFrom = moment(this.dateRangeView.dateFrom, this.dateRangeView.options.format).toISOString(true)
                this.updateDateParams()
            }
        },
        onDateToChanged() {
            if (this.dateRangeView.dateTo) {
                this.dateRange.dateTo = moment(this.dateRangeView.dateTo, this.dateRangeView.options.format).toISOString(true)
                this.updateDateParams()
            }
        },
        async refreshAll() {
            this.items = []
            this.page = 1
            this.infiniteId += 1
        },

        createDateRange() {
            const apiDateFormat = "YYYY-MM-DD HH:mm:ss"
            let data = {}
            switch (this.dateRange.type) {
                case CONSTANTS.TODAY: {
                    data.date_from_local = moment().startOf('day').format(apiDateFormat)
                    data.date_to_local = moment().endOf('day').format(apiDateFormat)
                    break;
                }
                case CONSTANTS.LAST7DAYS: {
                    data.date_from_local = moment().subtract(7, 'days').startOf('day').format(apiDateFormat)
                    data.date_to_local = moment().endOf('day').format(apiDateFormat)
                    break;
                }
                case CONSTANTS.CUSTOM: {
                    data.date_from_local = moment(this.dateRange.dateFrom).format(apiDateFormat)
                    data.date_to_local = moment(this.dateRange.dateTo).format(apiDateFormat)
                    break;
                }
            }
            return data
        },

        async loadLinks(stateInf) {
            try {
                console.log(`loadLinks`)
                const apiDateFormat = "YYYY-MM-DD HH:mm:ss"
                this.loadingAction = true
                let countPerPage = 100
                let data = {
                    page: this.page,
                    count_per_page: countPerPage,
                    search: this.search.filter,
                }
                let dataRange = this.createDateRange()
                data.date_from_local = dataRange.date_from_local
                data.date_to_local = dataRange.date_to_local
                const response = await this.getServiceLogs(data)
                if (this.page == 1) this.items = []
                this.page += 1;
                this.totalItems = response.total
                let items = response.items
                items.forEach((item) => {
                    this.items.push(item)
                })
                if (stateInf) {
                    if (items.length > 0) stateInf.loaded();
                    if (items.length < countPerPage) stateInf.complete();
                }
            } catch (e) {
                console.log(e)
                this.showErrorModal(e.data.error.message, {
                    title: 'Error',
                    code: e.data.error.code
                })
            } finally {
                this.loadingAction = false
            }
        },
        getServices(item) {
            let str = ''
            for (let i = 0; item.sec_level.length > i; i++) {
                if (i > 0) str += '\n'
                str += item.sec_level[i]
            }
            return str
        },
        openRateLocation(item) {
            let loc = item.rate_location
            let url = `https://www.google.com/maps/place/${loc.lat},${loc.lng}/@${loc.lat},${loc.lng},17z`
            window.open(url, '_blank')
        },
        onVoteImageClick(item) {
            window.open(item.originUrl, '_blank')
        },
        async fetchReport(type) {
            switch (type) {
                case 'xlsx':
                    logAnalyticsEvent(`analytics_generate_sl_xlsx_report_clk`)
                    break
            }
            let dataRange = this.createDateRange()
            let dateFromLocal = dataRange.date_from_local
            let dateToLocal = dataRange.date_to_local
            let placeUids = []
            let dataType = 'sl'
            let data = {
                date_from_local: dateFromLocal,
                date_to_local: dateToLocal,
                place_uids: placeUids,
                type: type,
                data_type: dataType,
            }
            try {
                if(this.totalItems < 30000) {
                    this.openFileReport({dateFromLocal, dateToLocal, placeUids, type, dataType})
                } else {
                    const response = await this.createXlsxReportTask(data)
                    this.$store.commit('owner/setReportGeneration', {
                        show: true,
                        progress: true,
                        downloadLink: null,
                        taskGuid: response.task.guid,
                    })
                }
            } catch (e) {
                console.log(e)
                logError('check_report', e.data.error.message || '')
                this.customModalSettings = {
                    sectionClass: 'full-width--btn large',
                    icon: 'ic_allow.svg',
                    message: this.translate('dataReportPopup'),
                    okButtonText: this.translate('Close'),
                    onOkHandler: () => {
                        this.customModalSettings = null
                    }
                }
            }
        },
    }
}
</script>

<style scoped>
.owner-panel-container {
    max-width: 98%;
    margin: 0 0;
}

.infinite-no-results {
    padding-top: 24px;
    padding-bottom: 24px;
    display: flex;
    flex-direction: column;
    align-items: center;
}

.infinite-no-results span {
    color: #4e4e4e;
}

.infinite-no-results button {
    margin-top: 16px;
}
.no_data_reset_btn {
    min-width: 150px;
    margin-top: 0 !important;
}
.refresh-btn {
    cursor: pointer;
    color: #4A85CB;
    display: flex;
    width: 100%;
    justify-content: flex-end;
    margin-top: 15px;
    padding-right: 15px;
}

.first-col {
    /*color: #4A85CB;*/
    /*text-decoration: underline;*/
}

.range {
    flex-direction: column;
    align-items: start;
}

.range-select {
    flex-direction: row;
    display: flex;
    width: 100%;
    align-items: start;
    row-gap: 12px;
    flex-wrap: wrap;
}

.range-select .search_places {
    width: 170px;
    background-color: #F7F7F7 !important;
    margin-top: -5px;
}

.range-select__wrapper {
    display: flex;
}

.custom_date_selector .form-control {
    height: 36px;
}

.dropdown-range {
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    background: #F7F7F7;
    padding: 5px 16px 12px;
    border-radius: 4px;
    margin-right: 16px;
}

.dropdown-range.dates {
    padding-top: 0;
    padding-bottom: 0;
    min-width: 320px;
}

.custom_date_selector {
    display: flex;
    flex-direction: row;
}

.custom_date_selector input {
    border-bottom: 1px solid black;
}

.custom_date_selector .hide-picker /deep/ .bootstrap-datetimepicker-widget {
    display: none !important;
}

.custom_date_selector .btn {
    width: auto;
    height: 20px;
    padding: 0;
    margin: auto;
}

.date_lbl {
    width: 50px;
    margin: auto;
    text-align: right;
    margin-right: 8px;
}


.main-container {
    position: fixed;
    max-width: 1280px;
    width: 95%;
    margin-top: 16px;
    background: #F3F3F3;
    display: flex;
    flex-direction: column
}

.items-container {
    padding-left: 16px;
    padding-right: 16px;
    padding-bottom: 16px;
    margin-top: 16px;
    width: 100%;
    margin-right: 16px;
    border-radius: 4px;
    min-height: 150px;
    overflow-x: auto;
    overflow-y: scroll;
    max-height: 95%;
    background: #ffffff;
    box-shadow: 0 2px 2px -1px rgba(0, 0, 0, 0.4);
}

.items-table {
    min-width: 100%;
    margin-top: 16px;
    border-collapse: collapse;
    font-size: 14px;
}

.table-header {
    position: sticky;
    top: 0;
    padding-top: 0;
    background: #ffffff;
    box-shadow: 0 2px 2px -1px rgba(0, 0, 0, 0.4);
    z-index: 100;
    border-top: none !important;
    color: black;
    background-color: #b9d99c;
    font-size: 15px;
}

.items-table .table-row {
    background: white;
    border-top: solid 1px rgba(109, 109, 109, 0.51);
    border-bottom: solid 1px rgba(109, 109, 109, 0.51);
    color: #2F2F2F;
}

.items-table .table-row.finished {
    background: rgb(243, 243, 243);
}

.items-table .table-row:hover {
    background: #FFEDC2FF;
    box-shadow: 0 2px 2px -1px rgba(0, 0, 0, 0.4);
}

.items-table td {
    vertical-align: baseline;
    text-align: start;
    padding: 4px;
    position: relative;
    border-right: solid 1px rgba(109, 109, 109, 0.51);
    border-left: solid 1px rgba(109, 109, 109, 0.51);
}

.first-col {
    border-left: none !important;
}

.last-col {
    border-right: none !important;
    pointer-events: none;
    cursor: pointer;
}

.last-col.active {
    pointer-events: inherit;
}


.vote-audio {
    height: 40px !important;
    width: 200px !important;
    max-width: 200px !important;
    display: block;
}

.attachments {
    height: 50px;
    min-width: 140px;
    overflow-x: auto;
    overflow-y: hidden;
    display: flex;
}

.attachments img {
    max-width: 100%;
    max-height: 50px;
    cursor: pointer;
    margin-right: 4px;
}

.range h6 {
    color: #2F2F2F;
    font-family: 'Nunito';
    font-weight: 700;
    font-size: 13px;
    letter-spacing: 0;
    line-height: 18px;
}

.range .dropdown /deep/ button.btn-secondary {
    background: none !important;
    border: 0;
    display: flex;
    align-items: center;
    color: #2F2F2F;
    font-weight: 700;
    position: relative;
    padding: 5px 50px 5px 0;
    margin-left: 0;
    font-size: 16px;
    font-family: 'Nunito';
}

.range /deep/ .dropdown-menu {
    width: auto !important;
}

.range .dropdown:before {
    position: absolute;
    bottom: 0;
    right: 0;
    left: 0;
    z-index: 1;
    content: " ";
    background: #3F405C;
    width: 100%;
    height: 1px;
}

.range .dropdown:after {
    content: '';
    height: 7px;
    width: 7px;
    transform: rotate(45deg);
    right: 10px;
    top: 10px;
    position: absolute;
    border-bottom: 2px solid black;
    border-right: 2px solid black;
}
@media screen and (max-width: 900px) {
    .range-select__wrapper {
        flex-direction: column;
    }
}

</style>
